import { defineMessages } from "react-intl"

export const inventoryAndIntakeContainerMessages = defineMessages({
	title: {
		defaultMessage: "Inventory information & source information",
		id: "vehicleDetails.overview.inventory.title",
	},
})
